import React from 'react'
import styled from 'styled-components'
import { UPLOAD_DRAFT_STATUS } from 'src/utils/invoiceUploadQueueHelpers'

const TONE_STYLES = {
  muted: { bg: '#f5f5f5', color: '#595959' },
  info: { bg: '#e6f7ff', color: '#096dd9' },
  success: { bg: '#f6ffed', color: '#389e0d' },
  danger: { bg: '#fff2f0', color: '#cf1322' },
}

function ReviewUploadsSidebar({ items = [], focusId = null, onSelect }) {
  return (
    <Sidebar>
      <SidebarTitle>Uploads</SidebarTitle>
      <SidebarList>
        {items.map(item => {
          const active = String(item.id) === String(focusId)
          const tone = TONE_STYLES[item.chipTone] || TONE_STYLES.muted
          const isCn = item.documentType === 'creditNote'
          return (
            <SidebarItem
              key={item.id}
              type='button'
              data-active={active ? 'true' : undefined}
              data-status={item.status}
              onClick={() => onSelect && onSelect(item.id)}
            >
              <SidebarItemTop>
                <SidebarName title={item.filename}>
                  {item.pickIndex + 1}. {item.filename}
                </SidebarName>
                <StatusChip style={{ background: tone.bg, color: tone.color }}>
                  {item.chipLabel}
                </StatusChip>
              </SidebarItemTop>
              <SidebarMeta>
                {isCn ? 'Credit note' : 'Invoice'}
                {item.status === UPLOAD_DRAFT_STATUS.READING ||
                item.status === UPLOAD_DRAFT_STATUS.QUEUED
                  ? ' · reading…'
                  : ''}
              </SidebarMeta>
            </SidebarItem>
          )
        })}
      </SidebarList>
    </Sidebar>
  )
}

export default ReviewUploadsSidebar

const Sidebar = styled.aside`
  width: 240px;
  flex-shrink: 0;
  border-right: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  min-height: 420px;
  max-height: min(70vh, 640px);
`

const SidebarTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8c8c8c;
  padding: 4px 12px 10px;
`

const SidebarList = styled.div`
  overflow-y: auto;
  flex: 1;
  padding-right: 4px;
`

const SidebarItem = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  padding: 10px 10px;
  margin-bottom: 4px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &[data-active='true'] {
    background: #f6ffed;
    border-color: #b7eb8f;
  }

  &:hover {
    background: #fafafa;
  }

  &[data-active='true']:hover {
    background: #f6ffed;
  }
`

const SidebarItemTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`

const SidebarName = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #262626;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`

const StatusChip = styled.span`
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1.4;
`

const SidebarMeta = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: #8c8c8c;
`
